import { render, staticRenderFns } from "./distcommissiontype.vue?vue&type=template&id=4b5e9f3a&"
import script from "./distcommissiontype.vue?vue&type=script&lang=js&"
export * from "./distcommissiontype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports